import { useEffect, useState } from "react"
import styled from "styled-components"
import { useLocale, useT } from "react-polyglot-hooks"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import Arrow from "components/icons/arrow"
import { color } from "helpers/styled"
import Faq from "./Faq"
import tm from "../../../theme";

export function mq(name) {
  const query = tm.breakpoints[name]

  if (!query) throw new Error(`Could not find size: ${name}`)
  return query
}

const Title = styled(Typography)`
  margin: 0;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  padding: 4px 10px 4px 0;
  border: solid 1px ${color("silver")};
  border-left: none;
  border-right: none;
`

const Dropdown = styled.div`
  max-height: 0;
  transition: max-height 0.25s ease-out;
  overflow: hidden;

  &.active {
    max-height: 100%;
    transition: max-height 0.35s ease-in;
  }
`

const StyledIcon = styled(Icon)`
  transform: rotate(0deg);
  transition: transform 0.25s ease-out;

  &.active {
    transform: rotate(90deg);
    transition: transform 0.25s ease-in;
  }
`

const Container = styled.div`
  width: 100%;
  padding: 10px 10px 0;
  margin: 0 auto;

  @media ${mq("lg")} {
    padding: 35px 0 25px;
  }

  @media ${mq("xl")} {
    padding: 50px 0 25px;
  }
`

export default function FlexibleFaqs() {
  const t = useT()
  const locale = useLocale()
  const [list, setList] = useState({})
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    import(`../../../../i18n/${locale}/flexible_faqs.json`).then(res => setList(res.default))
  }, [])

  const toggle = () => setIsOpen(!isOpen)

  return (
    <div css="margin: 50px 0" className={isOpen ? "show" : ""}>
      <Container>
        <Header onClick={toggle}>
          <Title variant="title3" el="h2" weight="medium" space>
            {t("common.faqs")}
          </Title>
          <StyledIcon size="xs" color="deepPink" className={isOpen ? "active" : null} Icon={Arrow} />
        </Header>
        <Dropdown className={isOpen ? "active" : null}>
          {Object.keys(list).map(key => (
            <Faq key={key} question={list[key].question} answer={list[key].answer} />
          ))}
        </Dropdown>
      </Container>
    </div>
  )
}
